<app-header (toogleSideBarForMe)="sideBarToogle()" ></app-header>
<mat-drawer-container>
    <mat-drawer mode="side" [opened]="sideBarOpen" class="sideBar">
        <app-siderbar ></app-siderbar>
    </mat-drawer>
    <mat-drawer-content class="toolbar1">
        <router-outlet></router-outlet>
    </mat-drawer-content>
</mat-drawer-container>
<app-footer></app-footer>